var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.4 17h4.4c.66 0 1.2-.53 1.2-1.2V9c0-.66-.4-1.55-.91-1.98L9 1 1.91 7.02C1.41 7.45 1 8.34 1 9v6.8c0 .67.54 1.2 1.2 1.2h4.4v-5.6h4.8V17Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgHome;